module.exports = __webpack_public_path__ + "static/media/icons-sequence.6f6c209b.svg";